<template>
  <router-view :key="Date.now()" />
</template>

<script>

export default {
  data () {
    return {}
  }
}
</script>
<style lang='scss' scoped>
</style>
